/**
 *
 * Recover Flow, for recovering already protected devices
 */
import {getClientFeatures, getDeviceData} from "./utils/recover_utils";
import {DEFAULT_RECOVER_FLOW_NAME, REPLIBIT_RECOVER_TYPE} from "./utils/recover_consts";
import ErrorStep from "./steps/error/error";
import TypeStep from "./steps/type";
import TypeStepRB from "./steps/type-rb";
import StartRunbookWarning from "./steps/start_runbook_warning";
import SetVirtualizationRunbook from "./steps/setup/set_virtualization_runbook";
import CreateRunbookFailover from "./steps/create/create_runbook_failover";
import SetRunbookVirtualizationType from "./steps/setup/set_runbook_virtualization_type";
import RevokeMount from "./steps/revoke_mount";
import ExportVmFailover from "./steps/export/export_vm_failover";
import SetVmExportFailover from "./steps/setup/set_vm_export_failover";
import ExportChangeFormat from "./steps/export/export_change_format";
import ExportVm from "./steps/export/export_vm";
import ExposeCifsShare from "./steps/expose_cifs_share";
import GenericError from "./steps/error/generic_error";
import ApplianceOffline from "./steps/appliance_offline";
import NotAvailable from "./steps/not_available";
import VmRunning from "./steps/vm_running";
import StartVm from "./steps/start_vm";
import ShowVmExist from "./steps/show_vm_exist";
import SetupLocalVm from "./steps/setup_local_vm";
import BrowseLocalVms from "./steps/browse/browse_local_vms";
import Restore from "./steps/restore";
import Browse from "./steps/browse/browse";
import SetRecoveryPoint from "./steps/setup/set_recovery_point";
import SetDrive from "./steps/setup/set_drive";
import SetJob from "./steps/setup/set_job";
import SetDevice from "./steps/setup/set_device";
import SetAppliance from "./steps/setup/set_appliance";
import ConductD2cBmr from "./steps/conduct_d2c_bmr";
import CreateFailoverFailed from "./steps/create/create_failover_failed";
import CreateFailover from "./steps/create/create_failover";
import SetVirtualizationFailover from "./steps/setup/set_virtualization_failover";
import ShowVoExist from "./steps/show_vo_exist";
import SetExportType from "./steps/setup/set_export_type";
import SetVirtualizationType from "./steps/setup/set_virtualization_type";
import LocateVirtualization from "./steps/locate_virtualization";
import RestoreType from "./steps/restore_type";
import RecoverToolSelectStep from "./steps/recover_tool_select";
import ExportVirtualDisk from "./steps/replibit/export_virtual_disk";
import RbExportType from "./steps/replibit/rb-export-type";
import RbSetDevice from "./steps/replibit/rb-set-device";
import SetPsPassword from "./steps/replibit/set_ps_password";
import SelectRestorePoint from "./steps/replibit/select_restore_point";
import RbRecoveryInProgress from "./steps/replibit/rb_recovery_in_progress";
import ExportComplete from "./steps/replibit/export_complete";
import ClientSelect from "./steps/client_select";
import SetVoVmsAutoStop from "./steps/setup/set_vo_vms_autostop";


export default class RecoverFlow {

  constructor(context, closeCallback, type) {
    this.context = context;
    this.closeCallback = closeCallback;
    this.name = DEFAULT_RECOVER_FLOW_NAME;
    this.defRecovery = {
      type: null,
      via: null,
      device_name: null,
      virtualization: null,
      restore: null,
      services: [],
    };
    this.context.type = type;
    this.defaultStartStep = type === REPLIBIT_RECOVER_TYPE ? 'typeRB' : 'type';
    this.initializeSteps();
  }

  open(data, el, fr) {
    const nextStep = data.startStep ? data.startStep : this.defaultStartStep;
    data.tmp = {};
    data.recovery = this.defRecovery;
    data.filemountUseId = null;
    if (data.deviceId) {
      getDeviceData(data, fr, () => fr.goTo(nextStep));
    } else if (data.clientId) {
      getClientFeatures(data, fr, () => fr.goTo(nextStep));
    } else {
      fr.goTo(nextStep);
    }

    return 'loading';
  }

  close(data) {
    data = $.extend(true, {}, {recovery: this.defRecovery}, data);
    if (data.filemountUseId) {
      $.post("/api/filebrowsing/complete/" + data.filemountUseId);
      data.filemountUseId = null;
    }
    if (this.closeCallback) {
      this.closeCallback();
    }
  }

  initializeSteps() {
    this.steps = {
      error: new ErrorStep(),
      type: new TypeStep(),
      typeRB: new TypeStepRB(),
      startRunbookWarning: new StartRunbookWarning(),
      setVirtualizationRunbook: new SetVirtualizationRunbook(),
      createRunbookFailover: new CreateRunbookFailover(),
      setRunbookVirtualizationType: new SetRunbookVirtualizationType(),
      revokeMount: new RevokeMount(),
      exportVmFailover: new ExportVmFailover(),
      setVmExportFailover: new SetVmExportFailover(),
      exportChangeFormat: new ExportChangeFormat(),
      exportVm: new ExportVm(),
      exposeCifsShare: new ExposeCifsShare(),
      genericError: new GenericError(),
      applianceOffline: new ApplianceOffline(),
      notAvailable: new NotAvailable(),
      vmRunning: new VmRunning(),
      startVm: new StartVm(),
      showVMExist: new ShowVmExist(),
      setupLocalVm: new SetupLocalVm(),
      browseLocalVms: new BrowseLocalVms(),
      restore: new Restore(),
      browse: new Browse(),
      setRecoveryPoint: new SetRecoveryPoint(),
      setDrive: new SetDrive(),
      setJob: new SetJob(),
      setDevice: new SetDevice(),
      setAppliance: new SetAppliance(),
      conductD2cBmr: new ConductD2cBmr(),
      createFailoverFailed: new CreateFailoverFailed(),
      createFailover: new CreateFailover(),
      setVirtualizationFailover: new SetVirtualizationFailover(),
      showVOExist: new ShowVoExist(),
      setExportType: new SetExportType(),
      setVirtualizationType: new SetVirtualizationType(),
      locateVirtualization: new LocateVirtualization(),
      restoreType: new RestoreType(),
      recoverToolSelect: new RecoverToolSelectStep(),
      exportVirtualDisk: new ExportVirtualDisk(),
      rbExportType: new RbExportType(),
      rbSetDevice: new RbSetDevice(),
      setPsPassword: new SetPsPassword(),
      selectRestorePoint: new SelectRestorePoint(),
      recoveryInProgress: new RbRecoveryInProgress(),
      exportComplete: new ExportComplete(),
      clientSelect: new ClientSelect(),
      setVoVmsAutoStop: new SetVoVmsAutoStop()
    }
  }

  runFlow() {
    new FlowRunner(this, this.context);
  }

}
